const pc = [
	// {
	// 	path: '/',
	// 	redirect: '/PCLogin'
	// },
	{
		name: 'introPage',
		path: '/introPage',
		component: () => import('@/view/introPage'),
		meta: {
			title: '首导页'
		}
	},
	{
		name: 'PCLogin',
		path: '/PCLogin',
		component: () => import('@/view/PC/login'),
		meta: {
			title: '登录页'
		},
	},
	{
		name: 'PChome',
		path: '/PChome',
		component: () => import('@/view/PC/home'),
		meta: {
			title: '首页',
			hasFooter: true
		},
		beforeEnter: (to, from, next) => {
			if (JSON.parse(localStorage.getItem("user")).isProperty == 0) {
				next({
					path: '/PChome2'
				})
			} else {
				next()
			}
		}
	},
	{
		name: 'PChome2',
		path: '/PChome2',
		component: () => import('@/view/PC/home/studentIndex.vue'),
		meta: {
			title: '首页',
			hasFooter: true
		},
		beforeEnter: (to, from, next) => {
			if (JSON.parse(localStorage.getItem("user")).isProperty == 1) {
				next({
					path: '/PChome'
				})
			} else {
				next()
			}
		}
	},
	{
		name: 'subjectEdit',
		path: '/subjectEdit',
		component: () => import('@/view/PC/subjectEdit'),
		meta: {
			title: '课程编辑'
		},
	},
]

export default pc